// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"682":"e7e2addb","702":"53247fb0"}[chunkId] + ".chunk.css";
};